import React, { useEffect, useMemo, useState } from "react"
import { useDispatch } from "react-redux"
import { get, map, forEach, find, isEmpty, remove } from "lodash"

import { APIResponse } from "redux/apis/types"

import { MenuPanel, Panel } from "./index"
import {
  BaseTable,
  HeatMapList,
  InfoTable,
  SeparateTable,
} from "components/molecules/table"
import { tableColumns, infoTableColumns } from "config/table_columns"
import { Labels } from "components/atoms/input/input"
import { MiniChartComponent } from "components/molecules/chart/miniChart"
import {
  changeSpModalSymbol,
  changeSymbol,
  changeTerm,
} from "redux/ducks/Chart"
import MiddleChart from "components/molecules/chart/middleChart"
import uuid from "uuid"
import ClassNames from "classnames"
import { LEG_TYPE_SELECT, ROUTE_LIST } from "config/const"
import { BaseSelect } from "components/atoms/input/select"
import { checkIsSp, checkIsBrowser } from "utils/util"
import { NewsList } from "./newsList"
import APIs from "redux/apis"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useLodingTrigger } from "components/actions/loading"
import { label } from "./future"
import { HeadInfo } from "components/organisms/panel/future"

type DataItem = {
  data: APIResponse.Res
  setData: Function
  num?: number
  changeNum?: Function
  listNum?: number
  changeListNum?: Function
  dataSp?: APIResponse.Res
}

type ComplexIndexPanelType = {
  industryItem: DataItem
  constituentsItem: DataItem
  detailItem: DataItem
  location: object
  chartID: {
    industry: string
    constituents: string
  }
  heatMapItem: {
    canvasId: string
    setInfoData: Function
  }
  labelItem: {
    label: number
    changeLabel: Function
  }
}

export const ComplexIndexPanelSp: React.FC<ComplexIndexPanelType> = props => {
  const {
    industryItem,
    constituentsItem,
    detailItem,
    location,
    chartID,
    heatMapItem,
    labelItem,
  } = props

  const dispatch = useDispatch()
  const loadResistId = useMemo(() => uuid(), [])
  const { loadingTrigger } = useLodingTrigger()
  const canvasIdOfIndustryData = useMemo(() => {
    return uuid()
  }, [])

  const [activeNewsTab, changeNewsTab] = useState(0)
  const [newsEffect, setNewsEffect] = useState(false)

  const industryDataList = get(industryItem.data, "ResultList", [])
  const constituentsList = get(constituentsItem.dataSp, "ResultList", [])

  const industryList = !isEmpty(industryDataList)
    ? map(industryDataList, (data: APIResponse.Res, i: number) => {
        return { id: i, name: get(data, "SymbolName") }
      })
    : [{ id: 0, name: "" }]

  useEffect(() => {
    heatMapItem.setInfoData(industryDataList[0])
  }, [industryDataList])

  useEffect(() => {
    if (isEmpty(constituentsItem.dataSp)) return
    const targetScroll = document.getElementById("Constituents")
    targetScroll.scrollTo(0, 0)
    if (activeNewsTab === 1) {
      changeNewsTab(0)
    } else {
      setNewsEffect(true)
    }
  }, [industryItem.num])

  useEffect(() => {
    if (isEmpty(constituentsItem.dataSp) || activeNewsTab === 1) return
    changeNewsTab(1)
  }, [constituentsItem.num])

  const industryLabel = [
    {
      id: 0,
      name: "一覧",
      component: [{}],
    },
    {
      id: 1,
      name: "ヒートマップ",
      component: (
        <HeatMapList
          data={industryItem.data}
          onClick={async (data: object, i: number) => {
            dispatch(changeSpModalSymbol(data))
          }}
          removeSymbolcode={true}
        />
      ),
    },
  ]

  return labelItem.label !== industryLabel[0].id ? (
    <Panel
      title=""
      className={ClassNames({
        "panel-heat-map": labelItem.label === industryLabel[1].id,
      })}
      filter={
        <div className="control-row filter-control-row sp">
          <Labels
            className="btn-segmented-control btn-thin liquid-control filter-control-item"
            labelList={industryLabel}
            onChange={(id: number) => {
              loadingTrigger.setLoading(true)
              labelItem.changeLabel(id)
              industryItem.changeNum(0)
              constituentsItem.changeNum(0)
            }}
            checked={labelItem.label}
          />
        </div>
      }
    >
      {get(find(industryLabel, { id: labelItem.label }), "component")}
    </Panel>
  ) : (
    <>
      <div className="square-contents">
        <Panel
          title=""
          className="square-panel"
          filter={
            <div className="control-row filter-control-row sp">
              <Labels
                className="btn-segmented-control btn-thin liquid-control filter-control-item"
                labelList={industryLabel}
                onChange={(id: number) => {
                  loadingTrigger.setLoading(true)
                  labelItem.changeLabel(id)
                }}
                checked={labelItem.label}
              />
              <BaseSelect
                option={industryList}
                value={industryItem.listNum}
                onChange={(id: number) => industryItem.changeListNum(id)}
              />
              <HeadInfo
                data={industryDataList[industryItem.listNum]}
                onClick={() =>
                  dispatch(
                    changeSpModalSymbol(
                      industryDataList[industryItem.listNum],
                      false,
                      true,
                      constituentsList[constituentsItem.num]
                    )
                  )
                }
              />
            </div>
          }
        >
          <div className="industry-table">
            <div>
              <SeparateTable
                className="table-list-view table-liquid-cell table-striped"
                list={tableColumns.index.industry.relate}
                data={constituentsList}
                onClick={async (data: object, i: number) => {
                  constituentsItem.changeNum(i)
                  dispatch(
                    changeSpModalSymbol(
                      industryDataList[industryItem.listNum],
                      false,
                      true,
                      data
                    )
                  )
                }}
                active={constituentsItem.num}
                scrollable={constituentsList.length > 7}
                scrollID="Constituents"
              />
            </div>
          </div>
        </Panel>
      </div>
    </>
  )
}
